//Fetch workers for the foreman to clock in/out via kyosk.
// To get the workers, foreman must be logged in, and the foremanId must be provided. 
// The foremnaId is the workerId 
// In the backend ensure the foremanId is actually a foreman at the jobsite. 
import axios from "axios";

const getWorkersKyosk_API = '/api/worker/foreman/getWorkers';

const getWorkersKyosk = async (token, jobsiteId, search = "", page = 1) => {
    try {
        const response = await axios.post(
            getWorkersKyosk_API,
            { jobsiteId, search, page },
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );
        return response.data;
    } catch (error) {
        console.log("Error fetching the user's workers" + error);
        throw error;
    }
}

export default getWorkersKyosk;